import { ApiEndpoint, ApiSubresourceEndpoint } from "./endpoints";
import { dispatchSubresourceRequest, Method } from "./dispatcher";

export interface MessageSignature {
	id: string;
	name: string;
	content: string;
}

export const getMessageSignatures = async () => {
	const r = await dispatchSubresourceRequest(
		ApiEndpoint.Settings,
		ApiSubresourceEndpoint.SettingsSignatures,
		Method.GET
	);

	return r.data;
};

export const addMessageSignature = async (data: MessageSignature) => {
	const r = await dispatchSubresourceRequest(
		ApiEndpoint.Settings,
		ApiSubresourceEndpoint.SettingsSignatures,
		Method.POST,
		null,
		null,
		data
	);

	return r.data;
};

export const patchMessageSignature = async (
	id: string,
	updateData: Partial<MessageSignature>
) => {
	const r = await dispatchSubresourceRequest(
		ApiEndpoint.Settings,
		ApiSubresourceEndpoint.SettingsSignatures,
		Method.PATCH,
		null,
		id,
		updateData
	);

	return r.data;
};

export const deleteMessageSignature = async (id: string) => {
	const r = await dispatchSubresourceRequest(
		ApiEndpoint.Settings,
		ApiSubresourceEndpoint.SettingsSignatures,
		Method.DELETE,
		null,
		id
	);

	return r.data;
};
